import React from 'react'
import { ItemContainer, ItemLabel } from '../../../../components/styled'
import { useMediaQuery, useTheme } from '@mui/material'

interface Props {
  items: { label: string; value?: string; testId?: string }[]
}

const PrintVariants = ({ items }: Props) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <>
      {items.map(
        (x) =>
          x.value && (
            <ItemContainer wrap={isSmall} key={x.label}>
              <ItemLabel variant={isSmall ? 'body2' : 'caption'}>{x.label}</ItemLabel>
              <ItemLabel variant='body2' data-testid={x.testId}>
                {x.value}
              </ItemLabel>
            </ItemContainer>
          ),
      )}
    </>
  )
}

export default PrintVariants
